<template>
  <RisksContentContainerWrapper
    class="mb-2 pa-3"
    wrapper-id="risks-content-electionwatch"
    :reset-expanded="resetExpanded"
  >
    <div>
      <div class="details-heading application-heading mb-4">
        Elections Watch
      </div>
      <div class="hyp-risk-content-electionwatch">
        <FutureEventsTimelineHolder
          :openedTimestamp="openedTimestamp"
          :params="params"
        />
      </div>
    </div>
  </RisksContentContainerWrapper>
</template>

<script>
import { nowUtc, daysAgo30Utc } from "@/common/date.utilities";

export default {
  name: "RisksCountryElectionWatch",
  components: {
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    FutureEventsTimelineHolder: () =>
      import("@/components/futureEvents/FutureEventsTimelineHolder"),
  },
  props: {
    isoCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      resetExpanded: null,
      openedTimestamp: new Date().toISOString(),
    };
  },
  computed: {
    params() {
      return {
        start: daysAgo30Utc(),
        end: nowUtc(),
        aoiId: this.isoCode.toUpperCase(),
        regionFilters: [],
        countryFilters: [this.isoCode.toUpperCase()],
      };
    },
  },
  watch: {
    isoCode: {
      handler() {
        this.resetExpanded = new Date().toISOString();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.hyp-risk-content-electionwatch {
  max-height: 30vh !important;
  overflow-y: auto !important;
}
.hyp-risks-content-expanded .hyp-risk-content-electionwatch {
  max-height: unset !important;
  overflow-y: auto !important;
}
</style>
